var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompteArbre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Compte",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.stcmpt0{fill:#FFFFFF;}\r\n\t.stcmpt1{fill:#605F71;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Bonhomme"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "stcmpt1",
    cx: 5.7,
    cy: 3.3,
    r: 3.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "stcmpt1",
    d: "M11.3,17H0v-4.5c0-3,2.4-5.4,5.4-5.4h0.5c3,0,5.4,2.4,5.4,5.4V17z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    className: "stcmpt1",
    width: 5.7,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 4.9,
    className: "stcmpt0",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 1.3,
    className: "stcmpt0",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 12,
    className: "stcmpt0",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 8.5,
    className: "stcmpt0",
    width: 1.7,
    height: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompteArbre);
export default __webpack_public_path__ + "static/media/Compte-arbre.b68c146d87770cc67b9261c3c90c058a.svg";
export { ForwardRef as ReactComponent };